import Icon from '@/components/ui/Icon/Icon';
import styles from './ActionBar.module.css';

type Props = {
  canAct: boolean;
  saving?: boolean;
  /** True briefly right after the share link is copied to the clipboard. */
  copied?: boolean;
  onSave: () => void;
  onShare: () => void;
  onOpenCompare: () => void;
  candidateCount: number;
};

// レポート末尾の共有・保存・比較。PDF 出力は B 向け機能なので、パートナー版が
// PdfExportPanel をこのバーの直前に差し込む (ReportWorkspace.renderExtraActions)。
export default function ActionBar({
  canAct,
  saving,
  copied,
  onSave,
  onShare,
  onOpenCompare,
  candidateCount,
}: Props) {
  return (
    <div className={styles.bar}>
      {/* 主ボタン = 結果のリンク。家族・仲介と URL で共有する導線。 */}
      <button
        type="button"
        className={styles.primary}
        onClick={onShare}
        disabled={!canAct}
      >
        <Icon name="link" size={18} />
        {copied ? 'リンクをコピーしました' : '結果のリンクをコピー'}
      </button>

      <button
        type="button"
        className={styles.secondary}
        onClick={onSave}
        disabled={!canAct || saving}
      >
        <Icon name="star" size={16} />
        候補地に保存
      </button>

      <button
        type="button"
        className={styles.secondary}
        onClick={onOpenCompare}
        disabled={candidateCount < 2}
      >
        <Icon name="sparkles" size={16} />
        候補地を比較 ({candidateCount})
      </button>
    </div>
  );
}
